import { Redirect, Route } from 'react-router'

import { buildLoginPathWithNext, getCurrentPathWithQuery } from 'utils/authRedirect'
import { isAuthenticated } from 'utils/backend'

const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={buildLoginPathWithNext(getCurrentPathWithQuery())} />
        )
      }
    />
  )
}

export default AuthRoute
